import { render } from "./MoreDetails.vue?vue&type=template&id=2913b7ce"
import script from "./MoreDetails.vue?vue&type=script&lang=js"
export * from "./MoreDetails.vue?vue&type=script&lang=js"

import "./MoreDetails.vue?vue&type=style&index=0&id=2913b7ce&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__